export const uppercaseFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
